import { useDispatch, useSelector } from "react-redux";
import { Printer, History, RefreshCcw } from "lucide-react";
import { toast } from "react-toastify";

import { useRefreshInventory } from "@/hooks/inventories/useInventories";

import { updateInventories } from "@/redux/actions/inventory.actions";
import CustomDropdown from "@/components/desktop/list/dropdown/CustomDropdown";
import CustomFetching from "@/components/desktop/fetching/CustomFetching";

const InventoryActions = ({ base, detail, print_tag_inventory, _index, _index_detail, handleShowMovements }) => {
	const dispatch = useDispatch();

	const { mutate: refresh, isLoading: loadRefresh } = useRefreshInventory();

	const { user } = useSelector((state) => state.auth);
	const { filter } = useSelector((state) => state.auth);
	const { estate_parent_id, estate_id, type_currency, search, parameter } = filter;

	const handleRecalculateCode = (detail) => {
		const newBase = { ...base, estate_parent_id, estate_id, type_currency, search, parameter };

		const form = {
			base: newBase,
			detail,
		};

		refresh(form, {
			onSuccess: (response) => {
				dispatch(updateInventories(response.inventories.data));

				toast.success("Consumo recalculado correctamente");
			},
		});
	};

	const showMovements = (detailArg) => {
		const newDetail = { ...detailArg, INVENTORY_ID: String(detailArg.ID_INVENTARIO) };
		handleShowMovements(newDetail);
	};

	const items = [
		...(detail?.IDENTIFICADOR
			? [
					{
						label: "Imprimir",
						action: () => print_tag_inventory(detail),
						icon: Printer,
					},
				]
			: []),

		{
			label: "Ver Movimientos",
			action: () => showMovements(detail),
			icon: History,
		},
		...(user?.superuser
			? [
					{
						label: "Recalcular Consumo",
						action: () => handleRecalculateCode(detail),
						icon: RefreshCcw,
					},
				]
			: []),
	];

	if (loadRefresh) {
		return <CustomFetching />;
	}

	return <CustomDropdown title="Acciones" items={items} align="right" />;
};

export default InventoryActions;
